import React from "react";
import styles from "./StepHeader.module.css";

function StepHeader({ formData }) {
  const incomes = formData.incomeExpenses || [];
  const assets = formData.assetsLiabilities?.filter((x) => x.type === "Asset") || [];
  const liabilities = formData.assetsLiabilities?.filter((x) => x.type === "Liability") || [];

  const totalIncome = incomes.reduce((acc, row) => acc + Number(row.amount || 0), 0);
  const totalAssets = assets.reduce((acc, row) => acc + Number(row.value || 0), 0);
  const totalLiabilities = liabilities.reduce((acc, row) => acc + Number(row.value || 0), 0);

  return (
    <div className={styles.header}>
      <div className={styles.card}>
        <h4>Total Income</h4>
        <p>${totalIncome.toLocaleString()}</p>
      </div>
      <div className={styles.card}>
        <h4>Total Assets</h4>
        <p>${totalAssets.toLocaleString()}</p>
      </div>
      <div className={styles.card}>
        <h4>Total Liabilities</h4>
        <p>${totalLiabilities.toLocaleString()}</p>
      </div>
    </div>
  );
}

export default StepHeader;
